module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/attribute/attribute.component.scss
// module id = ./src/app/shared/attribute/attribute.component.scss
// module chunks = main